"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgBoxCutter = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M7.22 11.91c-.33.33-.51.74-.56 1.17l5.51 2.36 8.49-8.48c.78-.79.78-2.05 0-2.83l-1.42-1.42c-.78-.78-2.04-.78-2.83 0l-9.19 9.2ZM5 16v5.75l5.81-5.22-5-2L5 16ZM17.12 4.83c.38-.39 1.03-.39 1.42 0 .39.4.39 1.03 0 1.42-.39.39-1.04.39-1.42 0-.39-.39-.39-1.02 0-1.42Z" })), 'SvgBoxCutter');
exports.default = SvgBoxCutter;
